<nz-badge [nzCount]="numOfItems"
  [nzStyle]="badgeStyle"
  [nzOffset]="badgeOffset"
>
  <i nz-icon nzType="icons/fontawesome/6.5.1/thin:cart-shopping" class="badge-icon"></i>
</nz-badge>
